/*
 * File: SelectCommercial.tsx
 * Project: autobuy-back-office
 * File Created: Friday, 8th September 2023 04:19:23
 * Author: Simon (s.gourlet@autobuy.fr)
 * -----
 * Last Modified: Wednesday, 4th October 2023 01:48:11
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright 2022 - 2023 SAS Olivier Dubois, SAS Olivier Dubois
 */

import { FormControl, MenuItem, Select, InputLabel } from "@mui/material";
import UserService from "Services/Users/UserService";
import { UserSimple } from "Type/user.type";
import { Dispatch, SetStateAction, useEffect, useState } from "react";

type SelectCommercialProps = {
    CommercialID?: string;
    className: string;
    valueName: string;
    onUpdate: Function;
    filteredCommercialID?: string;
    label: string;
    baseValue?: string;
    setNewCommercial?: Dispatch<SetStateAction<any | undefined>>;
}

const SelectCommercial = (props: SelectCommercialProps) => {
    const [commercial, setCommercial] = useState<UserSimple>();
    const [commercialList, setCommercialList] = useState<UserSimple[]>();

    const findUserByID = (userID: string, userList?: UserSimple[]) => {
        if (!userList || userList.length === 0)
            return undefined;
        let user = userList.find((val) => val.id === userID);
        if (user && user.id !== props.CommercialID)
            props.onUpdate({[props.valueName]: user.id});
        if (userID === props.baseValue)
            return { id: props.baseValue } as UserSimple;
        return user;
    }

    useEffect(() => {
        props.setNewCommercial?.(commercial);
    }, [commercial])

    useEffect(() => {
        UserService.getCommercials("VALID").then(
            (val: UserSimple[]) => {
                let filtered = val;
                if (props.filteredCommercialID)
                    filtered = val.filter(commercial => commercial.id !== props.filteredCommercialID);
                if (props.CommercialID)
                    setCommercial(findUserByID(props.CommercialID, filtered));
                else if (props.filteredCommercialID && filtered.length > 0)
                    setCommercial(filtered[0]);
                setCommercialList(filtered);
            }
        ).catch(reason => {
            console.error(`Unable to load commercials: ${reason.message}`);
        })
    }, []);

    return (
        <FormControl size="small">
            <InputLabel>{props.label}</InputLabel>
            <Select className={`${props.className} text-capitalize`} value={commercial ? commercial.id : ""} label={props.label} onChange={(e) => {setCommercial(findUserByID(e.target.value, commercialList))}}>
                {props.baseValue &&
                    <MenuItem value={props.baseValue} className="text-capitalize">
                        <em>{props.baseValue}</em>
                    </MenuItem>
                }
                {
                    commercialList ? commercialList.map(v =>
                        <MenuItem key={`role-${v.id}`} value={v.id} className="text-capitalize">
                            {`${v.FirstName} ${v.LastName}`}
                        </MenuItem>)
                        : null
                }
            </Select>
        </FormControl>
    )
}

export default SelectCommercial;
